import {
  CustomFontProperties,
  GoogleFontProperties,
} from 'common/utils/fontsUtils'
import {
  getButtonFontProperties,
  getNewButtonCustomFontProperties,
} from 'src/shared/entities/button/utils/get-button-font-properties'
import { FormInterface } from 'src/shared/types/entities/form-interface'
import { CustomFontsGenerator } from 'src/shared/utils/custom-fonts-generator'
import { GoogleFontsGenerator } from 'src/shared/utils/google-fonts-generator'

export function getFormFontProperties(entity: FormInterface) {
  const fontProperties: GoogleFontProperties[] = []

  fontProperties.push(...getButtonFontProperties(entity.buttonCommonStyles))
  fontProperties.push(
    ...GoogleFontsGenerator.getBaseTextEntityFontVariants(
      entity.checkboxesCommonStyles,
    ),
  )

  return fontProperties
}

export function getFormCustomFontProperties(entity: FormInterface) {
  const fontProperties: CustomFontProperties[] = []

  fontProperties.push(
    ...getNewButtonCustomFontProperties(entity.buttonCommonStyles),
  )
  fontProperties.push(
    ...CustomFontsGenerator.getBaseCustomFontProperties(
      entity.checkboxesCommonStyles,
    ),
  )

  return fontProperties
}
